module.exports = {"210421101":"石文镇","210421102":"后安镇","210421105":"上马镇","210421106":"救兵镇","210421204":"马圈子乡","210421209":"峡河乡","210421211":"海浪乡","210421216":"汤图满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210421.json
// module id = 536
// module chunks = 0